import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/remove-circled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5fd657c6")

_pushScopeId("data-v-5fd657c6")
const _hoisted_1 = {
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_2 = { class: "order-info-modal" }
const _hoisted_3 = { class: "order-dates" }
const _hoisted_4 = { class: "order-data-view-calendar" }
const _hoisted_5 = { class: "title-with-btn" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus fs-12" }, null, -1)
const _hoisted_8 = { class: "order-customer-items" }
const _hoisted_9 = { class: "order-customer-item" }
const _hoisted_10 = { class: "customer-field-title" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_12 = {
  key: 0,
  class: "customer-coupon-discount pl-6"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "customer-coupon-left"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "customer-row" }
const _hoisted_20 = {
  key: 0,
  style: {"gap":"10px"},
  class: "d-flex align-items-center"
}
const _hoisted_21 = {
  key: 0,
  class: "icon-f icon-coupon fs-14 cursor-initial"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "icon-f path1 fs-16 cursor-initial" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "icon-f path2 fs-16 cursor-initial" }, null, -1)
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  style: {"gap":"10px","justify-content":"space-between"},
  class: "d-flex align-items-center"
}
const _hoisted_26 = {
  key: 0,
  class: "icon-f icon-coupon fs-14 cursor-initial"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "icon-f path1 fs-16 cursor-initial" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "icon-f path2 fs-16 cursor-initial" }, null, -1)
const _hoisted_29 = { class: "customer-qty" }
const _hoisted_30 = { class: "customer-field-title" }
const _hoisted_31 = { class: "customer-field-title" }
const _hoisted_32 = { class: "customer-unit-price-value" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "customer-discount" }
const _hoisted_35 = { class: "customer-field-title" }
const _hoisted_36 = {
  key: 0,
  class: "customer-coupon-discount-value"
}
const _hoisted_37 = { class: "customer-total-price" }
const _hoisted_38 = { class: "customer-field-title" }
const _hoisted_39 = {
  key: 0,
  class: "customer-total-price-value"
}
const _hoisted_40 = {
  key: 1,
  class: "customer-total-price-value"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", null, "0", -1)
const _hoisted_42 = { class: "customer-remove" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OrderDataView = _resolveComponent("OrderDataView")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_OrderProductPrice = _resolveComponent("OrderProductPrice")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.save($event)), ["prevent"])),
    novalidate: "",
    id: "calendar-modal-create-order-form",
    ref: "formElementRef"
  }, [
    _createVNode(_component_OverlayModal, {
      isOpen: _ctx.isOpen,
      "onUpdate:isOpen": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpen = $event)),
      contentClass: "modal-limit",
      modalWidth: 840
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h1", null, _toDisplayString(_ctx.order.newproduct.productName), 1),
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(_ctx.getDateToTitle(_ctx.slot.startDate)) + " " + _toDisplayString(_ctx.slot.startTime) + " - " + _toDisplayString(_ctx.slot.endTime) + ", " + _toDisplayString(_ctx.getMinutes(_ctx.order.newproduct.slot.duration)) + " " + _toDisplayString(_ctx.$t('orders.min')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_OrderDataView, {
              modelValue: _ctx.order,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.order = $event)),
              "order-product-exist": false,
              channels: _ctx.channels,
              loaded: true,
              priceTypes: _ctx.priceTypes,
              clients: _ctx.clients,
              "is-group-price": _ctx.isGroupPrice,
              "incorrect-mobile": _ctx.incorrectMobile,
              "incorrect-email": _ctx.incorrectEmail,
              onEmailChanged: _ctx.emailChanged,
              onMobileNumberChanged: _ctx.mobileNumberChanged,
              onSubmitForm: _ctx.save,
              onGetPriceCustomersOnPriceTypeChange: _ctx.getPriceCustomersOnPriceTypeChange,
              onOnBussinessClientChange: _ctx.onBussinessClientChange
            }, null, 8, ["modelValue", "channels", "priceTypes", "clients", "is-group-price", "incorrect-mobile", "incorrect-email", "onEmailChanged", "onMobileNumberChanged", "onSubmitForm", "onGetPriceCustomersOnPriceTypeChange", "onOnBussinessClientChange"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('newOrder.addItem')), 1),
            _createVNode("span", {
              class: "rounded-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddCustomer && _ctx.onAddCustomer(...args)))
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.newproduct.customers, (item, i) => {
              return (_openBlock(), _createBlock("div", {
                class: "order-customer-item-template-shadow",
                key: i
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", {
                    class: ["customer-type", { 'customer-type-with-coupon': item.customerInfo.couponId }]
                  }, [
                    _createVNode("span", _hoisted_10, [
                      _createVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('customerType.customerType')) + " ", 1),
                        _hoisted_11,
                        (item.customerInfo.couponId && item.customerInfo.coupon)
                          ? (_openBlock(), _createBlock("span", _hoisted_12, [
                              (item.customerInfo.coupon.discountPercent)
                                ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(item.customerInfo.coupon.discountPercent) + "% ", 1))
                                : (item.customerInfo.coupon.discountAmount)
                                  ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(item.customerInfo.coupon.discountAmount) + " " + _toDisplayString(item.customerInfo.coupon.currencySymbol), 1))
                                  : (item.customerInfo.coupon.ticketFixedUnitPrice)
                                    ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(item.customerInfo.coupon.ticketFixedUnitPrice) + " " + _toDisplayString(item.customerInfo.currencySymbol), 1))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (item.customerInfo.couponId && item.customerInfo.coupon)
                        ? (_openBlock(), _createBlock("span", _hoisted_16, [
                            (item.customerInfo.coupon.limitationType == _ctx.couponLimitationType.TotalAmount)
                              ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.formatAmount(item.customerInfo.coupon.leftLimitationTotal)) + _toDisplayString(item.customerInfo.coupon.currencySymbol), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(item.customerInfo.coupon.leftLimitationTotal) + " " + _toDisplayString(_ctx.$t('label.tickets')), 1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('cashier.label.left')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_Dropdown, {
                        required: "",
                        modelValue: item.customerInfo,
                        "onUpdate:modelValue": ($event: any) => (item.customerInfo = $event),
                        options: _ctx.availableTypes(item),
                        optionLabel: "name",
                        class: "customer-ddl custom-multiselect-input",
                        onChange: ($event: any) => (_ctx.onChangeCustomerType($event, item)),
                        filter: !_ctx.isMobile,
                        filterBy: !_ctx.isMobile ? 'name' : null
                      }, {
                        value: _withId((slotProps) => [
                          (slotProps.value)
                            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                (slotProps.value.couponId)
                                  ? (_openBlock(), _createBlock("span", _hoisted_21, [
                                      _hoisted_22,
                                      _hoisted_23
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(slotProps.placeholder), 1))
                        ]),
                        option: _withId((slotProps) => [
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", null, _toDisplayString(slotProps.option.name), 1),
                            (slotProps.option.couponId)
                              ? (_openBlock(), _createBlock("span", _hoisted_26, [
                                  _hoisted_27,
                                  _hoisted_28
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange", "filter", "filterBy"])
                    ])
                  ], 2),
                  _createVNode("div", _hoisted_29, [
                    _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('newOrder.QTY')), 1),
                    _createVNode("div", null, [
                      _withDirectives(_createVNode("input", {
                        required: "",
                        class: ["bookit-input order-input w100 text-c qty-input", {
                                            warning: item.limitExceeded || _ctx.isWarning(item),
                                            invalid: _ctx.wasValidated && !item.quantity
                                        }],
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => (item.quantity = $event),
                        onInput: ($event: any) => {
                                            (item.limitExceeded = false),
                                                (_ctx.calculated = false),
                                                _ctx.debounce(() => {
                                                    _ctx.CalculateEventProductCustomers(item);
                                                })
                                        },
                        onPaste: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumber && _ctx.filterPastedOnlyNumber(...args))),
                        onKeypress: ($event: any) => (_ctx.filterKeyOnlyNumber($event), (item.limitExceeded = false)),
                        onChange: ($event: any) => (_ctx.filterKeyOnlyNumber($event), (item.limitExceeded = false))
                      }, null, 42, ["onUpdate:modelValue", "onInput", "onKeypress", "onChange"]), [
                        [_vModelText, item.quantity]
                      ])
                    ])
                  ]),
                  _createVNode("div", {
                    class: ["customer-unit-price", { 'customer-unit-price-editable': _ctx.canChangeUnitPrice }]
                  }, [
                    _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('newOrder.customerUnitPrice')), 1),
                    _createVNode("div", _hoisted_32, [
                      (_ctx.canChangeUnitPrice)
                        ? (_openBlock(), _createBlock(_component_InputNumber, {
                            key: 0,
                            required: "",
                            class: "priceForOne-input",
                            modelValue: item.priceForOne,
                            "onUpdate:modelValue": ($event: any) => (item.priceForOne = $event),
                            min: 0,
                            allowEmpty: false,
                            suffix: ' ' + _ctx.getCustomerPriceCurrencySymbol(item.id),
                            onInput: ($event: any) => {
                                            _ctx.onInputPriceForOne($event, item),
                                                _ctx.debounce(() => {
                                                    _ctx.CalculateEventProductCustomers(item);
                                                })
                                        }
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix", "onInput"]))
                        : (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.getCustomerPrice(item.id)) + _toDisplayString(_ctx.getCustomerPriceCurrencySymbol(item.id)), 1))
                    ])
                  ], 2),
                  _createVNode("div", _hoisted_34, [
                    _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('newOrder.discount')), 1),
                    (item.customerInfo.couponId)
                      ? (_openBlock(), _createBlock("div", _hoisted_36, _toDisplayString(_ctx.formatAmount(item.discountAmount)), 1))
                      : (_openBlock(), _createBlock(_component_InputNumber, {
                          key: 1,
                          class: "customer-discount-InputNumber calendar-customer-discount-InputNumber",
                          disabled: 
                                        !item.customerInfo.id || !item.quantity || item.quantity == 0 || _ctx.getCustomerPrice(item.id) == 0
                                    ,
                          modelValue: item.discountAmount,
                          "onUpdate:modelValue": ($event: any) => (item.discountAmount = $event),
                          suffix: item.customerInfo.currencySymbol,
                          min: 0,
                          allowEmpty: false,
                          onInput: ($event: any) => {
                                        (_ctx.calculated = false),
                                            _ctx.setDiscount($event, item),
                                            _ctx.debounce(() => {
                                                _ctx.CalculateEventProductCustomers(item);
                                            })
                                    }
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "suffix", "onInput"]))
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('priceList.price')), 1),
                    (_ctx.calculated)
                      ? (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(_ctx.formatAmount(item.price)) + _toDisplayString(_ctx.order.newproduct.currencySign), 1))
                      : (_openBlock(), _createBlock("div", _hoisted_40, [
                          _hoisted_41
                        ]))
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode("img", {
                      class: "",
                      src: _imports_0,
                      alt: "",
                      onClick: ($event: any) => (_ctx.deleteRow(i))
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createVNode(_component_OrderProductPrice, {
            priceTotalWithOutDiscount: _ctx.order.newproduct.priceTotalWithOutDiscount,
            discountTotal: _ctx.order.newproduct.discountTotal,
            price: _ctx.order.newproduct.price,
            currencySign: _ctx.order.newproduct.currencySign,
            customerTotalToPay: _ctx.order.newproduct.customerTotalToPay,
            businessClientTotalToPay: _ctx.order.newproduct.businessClientTotalToPay
          }, null, 8, ["priceTotalWithOutDiscount", "discountTotal", "price", "currencySign", "customerTotalToPay", "businessClientTotalToPay"])
        ]),
        _createVNode("button", {
          disabled: !_ctx.calculated,
          class: "save-button-wrapper popup-bookit-button px-5",
          type: "submit"
        }, _toDisplayString(_ctx.$t('button.create-order')), 9, ["disabled"]),
        _createVNode("button", {
          class: "close-button-wrapper popup-bookit-button px-5",
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.back()))
        }, _toDisplayString(_ctx.$t('button.close')), 1)
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 544))
})